
"use client" 

import * as React from "react"
import { cn } from "@/lib/utils"
import { useLocation } from "react-router-dom"

interface GridBackgroundProps {
  title: string
  description: string
  showAvailability?: boolean
  className?: string
  children?: React.ReactNode
}

export function GridBackground({
  title,
  description,
  showAvailability = true,
  className,
  children,
}: GridBackgroundProps) {
  const location = useLocation();
  const isProcessPage = location.pathname === "/services/process";
  const callToActionText = isProcessPage ? "Let's Talk" : "Call Now";
  
  return (
    <div 
      className={cn(
        'px-6 py-12 md:px-10 md:py-16 rounded-md relative flex items-center justify-center',
        className
      )}
      style={{
        backgroundColor: 'rgba(15, 15, 15, 1)',
        backgroundImage: `
          linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px'
      }}
    >
      <div 
        className="w-2 h-2 rounded-full absolute shadow-[0_0_15px] shadow-current z-10 bg-current"
        style={{
          animation: `
            border-follow 6s linear infinite,
            color-change 6s linear infinite
          `
        }}
      />
      <div 
        className="absolute inset-0 border border-white/10 rounded-md"
        style={{
          animation: 'border-color-change 6s linear infinite'
        }}
      />

      <div className="relative z-20 text-center max-w-3xl mx-auto w-full">
        <h2 className='text-xl md:text-2xl lg:text-3xl font-bold text-gold leading-tight'>{title}</h2>
        {description && (
          <p className='text-sm md:text-base mt-3 text-gray-300 max-w-xl mx-auto leading-relaxed'>{description}</p>
        )}

        {showAvailability && (
          <div className="available-now text-[#20bb5a] text-xs md:text-sm flex items-center justify-center mt-4">
            <div className="w-2 h-2 bg-[#20bb5a] rounded-full inline-block mr-2 animate-pulse shadow-[0_0_8px_#20bb5a]" />
            {callToActionText}
          </div>
        )}
        
        {children}
      </div>
    </div>
  )
} 
